<template>
  <div class="container text-start">
    <div class="d-flex justify-content-between">
      <span class="h3 fw-bold">Admin </span>
      <span class="my-2">Public Key: {{ publicKey }}</span>
    </div>
    <AdminTable :entries="getAdminEntries" />
    <div class="row">
      <div class="col">
        <AdminExport :entries="getAdminEntries" />
      </div>
      <div class="col">
        <AdminReset />
      </div>
    </div>
    <div class="row m-1">
      <AdminDisplayAnalytics />
    </div>
    <div class="row m-1">
      <AdminControlQuestions
        @edit-recommendations="handleEditRecommendations"
      />
    </div>
    <div class="row m-1" v-if="selectedQuestionUUID">
      <AdminControlResources :selectedQuestionUUID="selectedQuestionUUID" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import DatastoreAPI from "@/helpers/DatastoreAPI";

import AdminTable from "@/components/admin/AdminTable";
import AdminExport from "@/components/admin/AdminExport";
import AdminReset from "@/components/admin/AdminReset";

import AdminControlQuestions from "@/components/admin/AdminControlQuestions";
import AdminControlResources from "@/components/admin/AdminControlResources";
import AdminDisplayAnalytics from "@/components/admin/AdminDisplayAnalytics";
export default {
  name: "AdminView",
  mixins: [DatastoreAPI],
  components: {
    AdminTable,
    AdminExport,
    AdminReset,
    AdminControlResources,
    AdminControlQuestions,
    AdminDisplayAnalytics
  },
  data() {
    return {
      selectedQuestionUUID: null
    };
  },
  computed: {
    ...mapGetters("datastore", ["getAdminEntries"]),
    publicKey() {
      return process.env.VUE_APP_PUBLIC_KEY;
    }
  },
  created() {
    this.fetchQuestionData();
    this.fetchRecommendationData();
  },
  methods: {
    ...mapActions(["fetchQuestionData", "fetchRecommendationData"]),
    handleEditRecommendations(uuid) {
      this.selectedQuestionUUID = uuid;
    }
  }
};
</script>
